module.exports = __webpack_public_path__ + "static/media/havecard-4.9271cb9d.svg";